<script setup lang="ts">
import GaiaButton from '@/components/design/base/GaiaButton.vue';
import GaiaModal from '@/components/design/base/GaiaModal.vue';
import GaiaText from '@/components/design/base/GaiaText.vue';
import GaiaHeader from '@/components/design/base/GaiaHeader.vue';

/**
 * Blocks the page once the active organisation changed outside this tab: what
 * it shows belongs to the old one, and every further request would act on the
 * new one. Not dismissable — the only way on is a fresh load onto home.
 */
defineProps<{ show: boolean }>();

function reload(): void {
  window.location.assign('/');
}
</script>

<template>
  <gaia-modal :show="show" :closable="false" :mask-closable="false" :close-on-esc="false">
    <template #header>
      <gaia-header :level="2" size="dialog">Your active organisation changed</gaia-header>
    </template>
    <gaia-text>
      It was switched in another tab, or your membership changed. Reload to continue in the
      organisation that is active now.
    </gaia-text>
    <template #action>
      <n-flex justify="end" :size="8" :wrap="false">
        <gaia-button type="primary" @click="reload">Reload</gaia-button>
      </n-flex>
    </template>
  </gaia-modal>
</template>
